module.exports = __webpack_public_path__ + "img/gear.bdccd973.svg";